import { filterPayloadType } from "../Types/filterPayloadType";

export const dispatchMessageFormatter = (
    data: any,
    isDirectQuery: boolean,
    codeScreen: string,
    selectedMenu: string,
    parentName: string | undefined,
    createPopupName: string | undefined,
    deletePopupName: string | undefined,
    searchPageReset: string | undefined,
    searchId: string | undefined,
    description: string | undefined,
    previousParentName: string | undefined,
    previousQueryData: string | undefined,
    nestedSearchId: string | undefined,
    isSearchBoxTrigger?: boolean
    //isMeasurmentSearchFirst:boolean
): filterPayloadType => {

    let filterPayload: filterPayloadType = {
        data: data,
        isDirectQuery: isDirectQuery,
        codeScreen: codeScreen,
        selectedMenu: selectedMenu,
        parentName: parentName,
        createPopupName,
        deletePopupName,
        searchPageReset: searchPageReset,
        searchId: searchId,
        description: description,
        previousParentName: previousParentName,
        previousQueryData: previousQueryData,
        nestedSearchId: nestedSearchId,
        isSearchBoxTrigger: isSearchBoxTrigger
        //isMeasurmentSearchFirst:isMeasurmentSearchFirst
    }
    return filterPayload;
}